export type CounterpartyAccountType = 'checking' | 'savings';

export const COUNTERPARTY_ACCOUNT_TYPE_OPTIONS: { label: string; value: CounterpartyAccountType }[] = [
  {
    label: 'Checking',
    value: 'checking',
  },
  {
    label: 'Savings',
    value: 'savings',
  },
];

export const isCounterpartyAccountType = (value?: string | null): value is CounterpartyAccountType =>
  value === 'checking' || value === 'savings';

export const coerceCounterpartyAccountType = (value?: string | null): CounterpartyAccountType | undefined =>
  isCounterpartyAccountType(value) ? value : undefined;

export const formatCounterpartyAccountType = (value?: string | null) => {
  switch (value) {
    case 'checking':
      return 'Checking';
    case 'savings':
      return 'Savings';
    default:
      return value ? value.replace(/_/g, ' ').replace(/\b\w/g, (character) => character.toUpperCase()) : '-';
  }
};
